module.exports = __webpack_public_path__ + "img/carton_periodico.c5c0ca73.png";